import styles from "./Blog.module.css"
import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import LoadingScreen from "../components/LoadingScreen";
import Footer from "../../Footer/Footer";
import { FaArrowLeft } from "react-icons/fa";
import defaultImg from "../images/bloggen.jpg"



const BlogPage = () => {

  const { id } = useParams(); // e.g. /bloggen/1 -> "1"
  const API_BASE =
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000"
      : "https://api.hillerodfrimenighed.dk";

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;

    async function loadBlog() {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE}/blog/page/${encodeURIComponent(id)}`, {
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setBlog(data);
      } catch (e) {
        console.log(e.message || "Kunne ikke hente blogindlæg");
      } finally {
        setLoading(false);
      }
    }
    loadBlog();
  }, [id]); 

  const formattedDate = useMemo(() => {
    if (!blog?.created_at) return null;
    const d = new Date(blog.created_at); // works for "YYYY-MM-DD HH:mm:ss" or ISO
    if (isNaN(d)) return null;
    return d.toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" });
  }, [blog?.created_at]);

  if (loading) return <LoadingScreen/>
  if(!blog) return <div></div>
  return (
    <>
      <div className={styles.section}>
        <div className={styles.pageHead}>
          <div className={styles.pageHeadImg} style={{backgroundImage:`url(${blog.blog.blog_image || defaultImg})`}}/>
          <a href="/bloggen" className={styles.return}>
            <h3><FaArrowLeft/> Bloggen</h3>
          </a>
          <div className={styles.pageHeadInfo}>
            <h3>{formattedDate}</h3>
            <h1>{blog.blog.title}</h1>
          </div>
        </div>
        <div className={styles.authorInfo}>
          <div className={styles.authorImg} style={{backgroundImage: `url(${blog.author.image})`}}></div>
          <h3>{blog.author.name}</h3>
        </div>
        <hr className={styles.line}/>
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: blog.blog.content }}/>
        <div className={styles.authorBio}>
          <p style={{fontWeight:"600"}}>Om {blog.author.name}</p>
          <div dangerouslySetInnerHTML={{ __html: blog.author.bio }}/>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default BlogPage;
